import { FormControl, NgForm, Validators } from '@angular/forms';
import { endpoint } from '../../shared/endpoints.model';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { LoggerService } from "src/shared/logger/logger.service";
import { Levels } from 'src/shared/logger/levels.enum';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmationComponent } from 'src/shared/Dialogs/dialog-confirmation/dialog.confirmation.component';
import { SystemProfileService } from 'src/system-profile-manager/shared/system-profile-V2.service';
import { marketsLocations } from 'src/system-profile-manager/shared/markets.locations.model';

@Component({
  selector: 'system-location-password-component',
  templateUrl: './system-password.component.html',
  styleUrls: ['./system-password.component.css']
})
export class SystemPasswordComponent implements OnInit {

  endpoint_data: endpoint;
  systemMarketLocationData: { id: Number, market_name: string, location_name: string };
  panelOpenState1 = false;
  panelOpenState2 = false;
  panelOpenState3 = false;
  panelOpenState4 = false;



  updatePasswordError: string = null;
  updatePasswordError2: string = null;
  updateBtnErrorMsg: string = null;
  show_progressbar: boolean = false;
  system_password = new FormControl('', [Validators.required]);
  vms_system_password = new FormControl('', [Validators.required]);
  passwordProcessingFlag: boolean = false;
  toBeSentPassword: string = "";
  marketsData: marketsLocations[] = [];
  availableMarkets: { id: Number, text: string }[] = [];
  selectedMarketName: string = "";
  availableMarketLocations: { id: Number, text: string }[] = [];
  selectedMarketLocationId: { id: Number, text: string } = { id: null, text: null };
  @ViewChild('ff') passwordForm: NgForm;


  @Input() selected_parent_folder: any;
  @Input() selected_folder: any;
  @Output() endPoint_location_updated = new EventEmitter<string>();

  constructor(private loggerService: LoggerService,
    private systemService: SystemProfileService,
    private _snackBar: MatSnackBar, public dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.systemService.endpointDateToBeTransmitted.subscribe(data => {
      this.resetAllData();
      this.endpoint_data = data;
      if (this.endpoint_data && this.endpoint_data.market_location_id) {
        this.systemService.getSystemMarketLocation(this.endpoint_data?.system_ip).subscribe(data => {
          if (data["message"]?.id) {
            this.systemMarketLocationData = data["message"];
            setTimeout(() => {
              this.selectedMarketName = this.systemMarketLocationData.market_name;
              this.fetchMarketLocations();
              const location = this.availableMarketLocations.filter(i => i.id == this.systemMarketLocationData.id);
              this.selectedMarketLocationId = location[0];
            }, 100);
          }
        }, err => {
          this.loggerService.log("SystemPasswordComponent", err.message, Levels.error)
        })
      }
    }, err => {
      this.loggerService.log("SystemPasswordComponent", err.message, Levels.error)
    });

    this.systemService.getMarketsLocationsAvailable().subscribe(data => {
      this.marketsData = data.data;
      for (const market of this.marketsData) {
        if (this.availableMarkets.length == 0) this.availableMarkets.push({ id: market.id, text: market.market_name });
        else {
          if (this.availableMarkets[this.availableMarkets.length - 1].text !== market.market_name) this.availableMarkets.push({ id: market.id, text: market.market_name });
        }
      }
    }, err => {
      this.loggerService.log("SystemPasswordComponent", err.message, Levels.error)
    })


  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Update system location", message: `Are you sure you want to move ${this.endpoint_data?.system_name} from folder: ${this.selected_parent_folder?.text} to folder: ${this.selected_folder?.text}?` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onSubmit_update_location();
        document.getElementById('refreshID').click();
      }
    });
  }

  openDialogInsertNewPassword(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Update system password", message: `Are you sure you want to send this password to try connecting to unit?` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.send_new_password();
      }
    });
  }

  openDialogUpdateVmsPassword(): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: { title: "Update VMS system password", message: `Are you sure you want to send this password to try connecting to unit?` },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.update_vms_password();
      }
    });
  }

  disableUpdateButton(): boolean {
    let disableBtn = this.selected_folder == undefined ? true : false;
    if (this.selected_folder && disableBtn == false) {
      if (this.selected_folder?.value.id == this.endpoint_data?.folder_id_id) {
        this.updateBtnErrorMsg = "* You chose the same parent folder."
        disableBtn = true;
        return disableBtn;
      } else if (this.selected_folder?.internalChildren && this.selected_folder?.internalChildren?.length > 0
        && this.selected_folder.internalChildren[0].value.type == 'folder') {
        this.updateBtnErrorMsg = "* Cannot move an endpoint to a folder that contains folder(s)."
        disableBtn = true;
        return disableBtn;
      }
    }
    return disableBtn;
  }

  onSubmit_update_location() {
    if (this.disableUpdateButton() == false) {
      this.systemService.updateEndpointFolder(this.endpoint_data?.id, this.selected_folder?.value.id, this.endpoint_data?.system_ip).subscribe(response => {
        this.openSnackBar('Update location is finished', "Success");
        this.loggerService.log("SystemPasswordComponent", `request to change the folder for unit id=${this.endpoint_data?.id} to be moved to folder with id =${this.selected_folder?.value.id} was successful.`, Levels.info)
        this.endPoint_location_updated.emit("folder");
      }, err => {
        this.loggerService.log("SystemPasswordComponent", err.message, Levels.error)
        this.openSnackBar('Error occurred please check your data', "Error");
      })
    }
  }


  updateSystemPassword() {
    let password = this.system_password.value
    this.updatePasswordError = null;
    // if (password.length < 6 || ! /[A-Z]/.test(password) || !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password)) {
    //   if (password.length < 6) {
    //     this.updatePasswordError = "* Password must be of min 6 characters.";
    //   } else {
    //     this.updatePasswordError = "* Password must contain an upper case, lower case and a special character.";
    //   }
    //   return;
    // }
    this.push_to_system_new_password(password);

  }

  push_to_system_new_password(new_password: any) {
    this.show_progressbar = true
    this.passwordProcessingFlag = true;
    this.systemService.tryChangeSystemPassword(this.endpoint_data?.id, new_password).subscribe(data => {
      this.passwordProcessingFlag = false;
      this.endpoint_data.system_password = 1;
      this.endpoint_data.enable_phonebook = this.endpoint_data.enable_phonebook == '1' ? "On" : "Off"
      this.endpoint_data.enable_sip = this.endpoint_data.enable_sip == '1' ? "On" : "Off"
      this.endpoint_data.enable_h323 = this.endpoint_data.enable_h323 == '1' ? "On" : "Off"
      this.systemService.endpointDateToBeTransmitted.next(this.endpoint_data)
      this.show_progressbar = false;
      this.openSnackBar("Password changed", "Success")
    }, err => {
      this.passwordProcessingFlag = false;
      this.loggerService.log("SystemPasswordComponent", err.message, Levels.error);
      this.show_progressbar = false;
      this.openSnackBar("Connection error password could not be changed", "Error")

    })
  }

  fetchMarketLocations() {
    this.availableMarketLocations = [];
    this.selectedMarketLocationId = { id: null, text: null };
    const locations = this.marketsData.filter(i => i.market_name == this.selectedMarketName)
    for (const location of locations) {
      this.availableMarketLocations.push({ id: location.id, text: location.location_name });
    }
    this.selectedMarketLocationId = this.availableMarketLocations[0];
  }

  send_new_password() {
    if (this.passwordForm.valid) {
      this.passwordProcessingFlag = true;
      this.systemService.tryInsertFirstPassword(this.endpoint_data?.system_ip,
        this.selectedMarketLocationId.id, this.toBeSentPassword).subscribe(data => {
          this.passwordProcessingFlag = false;
          data["message"].enable_phonebook = data["message"].enable_phonebook == '1' ? "On" : "Off"
          data["message"].enable_sip = data["message"].enable_sip == '1' ? "On" : "Off"
          data["message"].enable_h323 = data["message"].enable_h323 == '1' ? "On" : "Off"
          this.systemService.endpointDateToBeTransmitted.next(data["message"]);
          this.loggerService.log("SystemPasswordComponent", `First password were pushed successfully for unit with id =${this.endpoint_data.id}`, Levels.info)
          this.openSnackBar('Password push is completed', "Success");
        }, err => {
          this.passwordProcessingFlag = false;
          this.loggerService.log("SystemPasswordComponent", err.error.message ? err.error.message : "Error while sending data", Levels.error)
          this.openSnackBar(err.error.message ? err.error.message : "Error while sending data", "Error");
        })
    }

  }

  update_vms_password() {
    let password = this.vms_system_password.value
    this.updatePasswordError2 = null;
    if (password.length < 6 || ! /[A-Z]/.test(password) || !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(password)) {
      if (password.length < 6) {
        this.updatePasswordError2 = "* Password must be of min 6 characters.";
      } else {
        this.updatePasswordError2 = "* Password must contain an upper case, lower case and a special character.";
      }
      return;
    }
    this.passwordProcessingFlag = true;
    this.systemService.updateVMSPassword(this.endpoint_data?.system_ip, password).subscribe(data => {
      this.passwordProcessingFlag = false;
      this.endpoint_data.system_password = 1;
      this.endpoint_data.enable_phonebook = this.endpoint_data.enable_phonebook == '1' ? "On" : "Off"
      this.endpoint_data.enable_sip = this.endpoint_data.enable_sip == '1' ? "On" : "Off"
      this.endpoint_data.enable_h323 = this.endpoint_data.enable_h323 == '1' ? "On" : "Off"
      this.systemService.endpointDateToBeTransmitted.next(this.endpoint_data)
      this.openSnackBar("Password change to VMS is done", "Success")
    }, err => {
      this.passwordProcessingFlag = false;
      this.loggerService.log("SystemPasswordComponent", err.message, Levels.error);
      this.openSnackBar("Connection error password could not be changed on VMS", "Error")
    })
  }

  updateSystemMarket() {
    this.systemService.updateSystemMarket(this.endpoint_data?.system_ip, this.selectedMarketLocationId.id).subscribe(data => {
      this.openSnackBar('System market is updated', "Success");
    }, err => {
      this.loggerService.log("SystemPasswordComponent", err.message, Levels.error)
    })
  }

  resetAllData() {
    this.updatePasswordError = null;
    this.updateBtnErrorMsg = null;
    this.show_progressbar = false;
    this.passwordProcessingFlag = false;
    this.toBeSentPassword = "";
    this.selectedMarketName = "";
    this.availableMarketLocations = [];
    this.selectedMarketLocationId = { id: null, text: null };
  }
}
